<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3>
        <i class="fa-solid fa-globe me-2"></i>
        <ng-container *ngIf="viewMode === ViewMode.INSERT">Land anlegen</ng-container>
        <ng-container *ngIf="viewMode === ViewMode.EDIT">Land bearbeiten</ng-container>
        <ng-container *ngIf="viewMode === ViewMode.VIEW">Land</ng-container>
    </h3>
</div>

<form [formGroup]="form">
    <div class="row">
        <div class="col">
            <label>Kürzel</label>
            <input type="text" class="form-control" formControlName="short" *ngIf="viewMode !== ViewMode.VIEW">
            <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.short }}</p>

            <label>Name</label>
            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode !== ViewMode.VIEW">
            <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.name }}</p>
        </div>
    </div>

    <h4>Standorte</h4>

    <button type="button" class="btn btn-primary" *ngIf="viewMode !== ViewMode.VIEW" (click)="addFormItem(form, 'locations')">
        <i class="fas fa-plus"></i> Standort hinzufügen
    </button>

    <table class="table table-striped table-sm">
        <thead>
        <tr>
            <th *ngIf="viewMode !== ViewMode.VIEW"></th>
            <th>Name</th>
        </tr>
        </thead>
        <tbody formArrayName="locations">
        <ng-container [formGroupName]="i" *ngFor="let location of formService.getFormArray(form, 'locations').controls; let i = index">
            <tr *ngIf="!location.value._deleted">
                <td *ngIf="viewMode !== ViewMode.VIEW">
                    <button type="button" class="btn btn-primary" (click)="deleteLocation(i)">
                        <i class="fas fa-trash"></i>
                    </button>
                </td>
                <td>
                    <input type="text" class="form-control" formControlName="name" *ngIf="viewMode !== ViewMode.VIEW">
                    <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ location.value.name }}</ng-container>
                </td>
            </tr>
        </ng-container>
        </tbody>
    </table>

    <p class="text-muted mt-2" *ngIf="form.value.locations.length === 0">Keine Standorte hinzugefügt</p>

</form>

<div style="border-top: 1px solid #dee2e6" class="mt-3 py-3">
    <ng-container *ngIf="viewMode === ViewMode.VIEW">
        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
        <button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="save()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
    </ng-container>
</div>
